import { FilterX, X } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

// Simplified interface for nuqs-based filters
interface SelectionSummaryProps {
  // Active nuqs filters
  type?: string[]
  setType?: (statuses: string[]) => void
  typeOptions?: { value: string; label: string }[]
  activePaymentStatuses?: string[]
  setActivePaymentStatuses?: (statuses: string[]) => void
  paymentStatusOptions?: { value: string; label: string }[]
  searchQuery: string
  activeOrigins?: string[]
  setActiveOrigins?: (origins: string[]) => void
  originsOptions?: { value: string; label: string }[]
  setSearchQuery: (searchQuery: string) => void
  handleClearFilters: () => void
}

export const SelectionSummary = ({
  type,
  setType,
  typeOptions,
  activePaymentStatuses,
  setActivePaymentStatuses,
  paymentStatusOptions,
  searchQuery,
  setSearchQuery,
  handleClearFilters,
  activeOrigins,
  setActiveOrigins,
  originsOptions,
}: SelectionSummaryProps) => {
  // Check if any filters are active
  const hasActiveFilters = searchQuery !== ''

  const handleSearchClear = () => {
    setSearchQuery('')
  }

  const handleClearAll = () => {
    handleClearFilters()
  }

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {/* Order Status Filter Badge */}

      {/* Search Query Badge */}
      {searchQuery && (
        <Badge
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>Búsqueda: {searchQuery}</span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={handleSearchClear}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      )}

      {/* Clear All Filters Button */}
      {hasActiveFilters && (
        <Button
          variant="ghost"
          size="sm"
          className="h-7 gap-1 text-xs"
          onClick={handleClearAll}
        >
          <FilterX className="h-3.5 w-3.5" />
          Limpiar filtros
        </Button>
      )}
    </div>
  )
}
